// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-6d06402f] {\n  min-height: calc(var(--vh) * 100);\n  background-color: #e8e8e8;\n}\n", ""]);
// Exports
module.exports = exports;
